module.exports = __webpack_public_path__ + "static/img/杉橙.f8833f0a.png";